export default __webpack_public_path__ + "static/media/2.5370b3ad.jpg";